import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_secured/agency-hub')({
  loader: async ({ context }) => {
    const i18n = await context.getInstance('i18n', '@mint/routing');
    await context.getInstance('i18n', '@myn/company');
    const title = i18n.t('Agency Hub | MINT');
    return { title };
  },
  head({ loaderData }) {
    const title = loaderData?.title;

    return {
      meta: [
        {
          title,
        },
      ],
    };
  },
});
